import React, {useState} from "react";
import { Button, Column, Columns, Input, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import ContactSection from "../Contact/ContactSection";
import axios from "axios";

export default function CreateJobModal({endpoint, open, setOpen, data, setData}){
    const [jobState, setJobState] = useState(data);

    const onChange = e => {
        let newJob = {...jobState, [e.target.name]:e.target.value}
        setJobState(newJob);
    };

    const onContactChange = (e, name, field) => {
        const toUpdate = {
            target: {
                name: name,
                value: e[field]
            }
        };
        onChange(toUpdate);
    };

    const clear = e => {
        setJobState({});
        setData({});
    };

    const onSave = e => {
        let dataToSave = {}
        const conf = {
            url: endpoint+"createjob",
            method: "post",
            data: jobState
        };
        axios(conf).then(res => {
            window.open(`/editjob/${res.data.id}`, "_self");
        }).catch(err => {
            console.log(err)
        })
    }




    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            closeOnBlur
            active={open}
            onClose={() => {
              clear();
              setOpen(false);
            }}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Create Job</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <ContactSection
                                title="Workshop"
                                contactUpdate={workshop => onContactChange({workshop}, "workshop", "workshop")}
                                endpoint={endpoint + "contacts"}
                                contact={jobState.workshop || {}}
                                type="SP"
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <ContactSection
                                title="Customer 1"
                                contactUpdate={customer => onContactChange({customer}, "customer", "customer")}
                                endpoint={endpoint + "contacts"}
                                contact={jobState.customer || {}}
                                type="CC"
                            />
                        </Column>
                        <Column>
                            <ContactSection
                                title="Customer 2"
                                contactUpdate={customer => onContactChange({customer}, "customer2", "customer")}
                                endpoint={endpoint + "contacts"}
                                contact={jobState.customer2 || {}}
                                type="CC"
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Book In Date</label>
                            <Input
                                type={"date"}
                                name={"book_in_date"}
                                onChange={onChange}
                                value={jobState.book_in_date}
                            />
                        </Column>
                        <Column>
                            <label className="label">Vehicle</label>
                            <Input
                                disabled={true}
                                type={"text"}
                                value={jobState.vehicle ? jobState.vehicle.registration : ""}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={onSave}
                                isFullWidth
                            >
                                Create
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() =>{
                                    clear();
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );



}